import React, { useContext } from "react";
import '../style/body-style.css'
import CK_en from "../resources/CK_en.json"
import CK_fr from "../resources/CK_fr.json"
import LanguageContext from "./LanguageContext";

function Footer() {
    const { language } = useContext(LanguageContext);
    const CK = language === 'en' ? CK_en : CK_fr;
    const isProd = window.location.host.includes("www.appmybizaccount.gov.on.ca");


    return (
        <div className="footer-wrapper">
            <footer className='ontario-footer ontario-footer--default' style={{width: '100%'}}>
                <div className='ontario-row'>
                    <div className='ontario-columns ontario-small-12'>
                        <ul className='ontario-footer__links-container ontario-footer__links-container--inline'>
                            <li><a className='ontario-footer__link' href={CK["footer.accessibility.link"]}>{CK["footer.accessibility"]}</a></li>
                            <li><a className='ontario-footer__link' href={CK["footer.privacy.link"]}>{CK["footer.privacy"]}</a></li>
                            <li><a className='ontario-footer__link' href={CK["footer.contact.link"]}>{CK["footer.contact"]}</a></li>
                            <li><a className='ontario-footer__link' href={CK["footer.terms.link"]}>{CK["footer.terms"]}</a></li>
                        </ul>
                        <div className='ontario-footer__copyright'>
                            <a className='ontario-footer__link' href={CK["footer.copyright.link"]}>&copy; {CK["footer.copyright"]}
                                <span className='ontario-nbsp'> 2012-25</span></a>
                        </div>
                    </div>
                </div>
            </footer>
        </div>

    );
}

export default Footer;
